import { render, staticRenderFns } from "./GeneralStructure.vue?vue&type=template&id=73a8eda8&scoped=true&"
import script from "./GeneralStructure.vue?vue&type=script&lang=js&"
export * from "./GeneralStructure.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStructure.vue?vue&type=style&index=0&id=73a8eda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a8eda8",
  null
  
)

export default component.exports